import React, { ReactNode, useEffect, useRef, useState } from "react";

import { Carousel } from "react-responsive-carousel";
import { GeneralObject } from "../../../definitions/general";
import { PropertyImage } from "../../../definitions/property";
import { gtag } from "../../../utils/track";
import Flex from "../../structure/Flex";
import ImageSlideshow from "../ImageSlideshow";
import { trackZostelEvent } from "../../../utils/tracking";
interface ImageCarouselProps {
  images: PropertyImage[];
  height?: string;
  carouselProps?: GeneralObject;
  imageFit?: "contain" | "cover";
  showTitle?: boolean;
  isSlideshow?: boolean;
  onClickItem?: (index: number, item: React.ReactNode) => void;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  carouselProps,
  height,
  imageFit,
  showTitle,
  isSlideshow,
  onClickItem,
}) => {
  const [slideshowVisible, setSlideshowVisible] = useState<boolean>(false);
  const selectedItem = useRef<number>(0);
  const ref = useRef<HTMLImageElement | null>(null);

  const [clientWidth, setClientWidth] = useState<number | null>();

  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef<Carousel>(null);

  useEffect(() => {
    const carouselRefEl = carouselRef.current;
    const handleKeyDown = (event: KeyboardEvent) => {
      let newIndex;

      if (event.key === "ArrowRight") {
        newIndex = (currentIndex + 1) % images.length;
      } else if (event.key === "ArrowLeft") {
        newIndex = (currentIndex - 1 + images.length) % images.length;
      } else {
        return; // Ignore other keys
      }

      setCurrentIndex(newIndex);
    };

    if (carouselRefEl) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (carouselRefEl) {
        document.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [currentIndex, images.length]);

  useEffect(() => {
    setClientWidth(ref.current?.clientWidth);
  }, []);

  const handleClick = (index: number, item: ReactNode) => {
    console.log(index, item);
    selectedItem.current = index;
    setSlideshowVisible(true);
  };

  const handleChange = (index: number, item: ReactNode) => {
    setCurrentIndex(index);
  };
  const handleAnalytics = (index: number) => {
    gtag("event", "Image_Click", { value: images[index].title });
    trackZostelEvent("Image_Click", { value: images[index].title });
  };
  return (
    <>
      <Carousel
        {...carouselProps}
        onClickItem={onClickItem || handleClick}
        useKeyboardArrows
        ref={carouselRef}
        onChange={handleChange}
        selectedItem={currentIndex}
        onClickThumb={handleAnalytics}
      >
        {images.map((image) => (
          <Flex
            items="center"
            justify="center"
            className={`w-full h-full ${isSlideshow ? "py-8" : ""}`}
            style={{ maxHeight: "80vh" }}
            key={image.id}
          >
            <img
              src={
                clientWidth
                  ? `${image.image}${
                      isSlideshow
                        ? "?w=1280"
                        : ref.current
                        ? `?w=${Math.ceil(clientWidth / 50) * 50}`
                        : ""
                    }`
                  : ""
              }
              alt={image.title}
              ref={ref}
              className={`w-full ${height ? height : "h-full"} ${
                imageFit === "contain" ? "object-contain" : "object-cover"
              } object-center cursor-zoom-in`}
            />
            {showTitle && (
              <p
                className={isSlideshow ? "legend ss-legend" : "legend"}
                style={{
                  color: "#fefefe",
                  opacity: 1,
                  backgroundColor: "rgba(0,0,0,0.25)",
                }}
              >
                {image.title}
              </p>
            )}
          </Flex>
        ))}
      </Carousel>
      {slideshowVisible && (
        <ImageSlideshow
          close={setSlideshowVisible.bind(null, false)}
          images={images}
          carouselProps={{
            showIndicators: false,
            selectedItem: selectedItem.current,
            infiniteLoop: true,
          }}
        />
      )}
    </>
  );
};

export default ImageCarousel;
